/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Total_OverdueInputs */

const vi_report_total_overdue = /** @type {(inputs: Report_Total_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quá hạn`)
};

/**

* @param {Report_Total_OverdueInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_total_overdue = /** @type {((inputs?: Report_Total_OverdueInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Total_OverdueInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_total_overdue(inputs)
});